import React from 'react';
import BrandHeader from './BrandHeader';
import LegalFooter from './LegalFooter';

export default function CompletionScreen({ data }) {
  return (
    <div className="container">
      <BrandHeader branding={data.branding} />
      <div className="card stack">
        <span className="badge success">Confirmation Complete</span>
        <h1 className="h1">Thanks{data.firstName ? `, ${data.firstName}` : ''} — your confirmations have been sent.</h1>
        <p>Your confirmation emails have been sent to your lenders successfully.</p>
        <p>Copies have also been sent to Fair so we can continue progressing your claim.</p>
        {data.completionCopy ? <p className="muted">{data.completionCopy}</p> : null}
      </div>
      {data.supportEmail ? (
        <div className="card small muted">
          Need anything else? Contact us at <a className="link-action" href={`mailto:${data.supportEmail}`}>{data.supportEmail}</a>.
        </div>
      ) : null}
      <LegalFooter disclosure={data.legalDisclosure} />
    </div>
  );
}
